import React from 'react';
import { ArrowRightIcon, ClockIcon, TargetIcon, FolderOpenIcon } from 'lucide-react';
import { BRAND, DEMO_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { Eyebrow } from '../ui/Eyebrow';
import { Reveal } from '../ui/Reveal';
const REASSURANCE = [{
  icon: ClockIcon,
  text: '20–30 minute personalized walkthrough.'
}, {
  icon: TargetIcon,
  text: 'No generic product tour.'
}, {
  icon: FolderOpenIcon,
  text: 'Bring your fund, mandate, investment thesis or existing dealflow.'
}];
export function FinalCta() {
  return <section aria-labelledby="final-cta-heading" className="relative overflow-hidden bg-ink" data-id="element-73" data-mp="1ca3y9r77rbtp">
      <div className="sf-grid-texture sf-fade-mask pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-74" data-mp="17b0pbvo44lgg" />
      <div aria-hidden="true" className="pointer-events-none absolute bottom-[-35%] left-1/2 h-[640px] w-[1000px] -translate-x-1/2 rounded-full" style={{
      background: 'radial-gradient(circle, rgba(32,22,95,0.07), transparent 62%)'
    }} data-id="element-75" data-mp="12c68gz9ph6yz" />

      <div className="relative mx-auto w-full max-w-[1320px] px-4 py-24 sm:px-6 lg:px-8 lg:py-32" data-id="element-76" data-mp="2jei4gtupqzsg">
        <Reveal className="mx-auto flex max-w-4xl flex-col items-center gap-6 text-center" data-id="element-77" data-mp="2nig7vgr2mwrb">
          <Eyebrow data-id="element-78" data-mp="29if5txz2lja9">Book a Demo</Eyebrow>
          <h2 id="final-cta-heading" className="sf-display text-balance text-[40px] leading-[1] text-text-primary sm:text-[60px] lg:text-[76px]" data-id="element-79" data-mp="29jgkecfaonwq">
            Bring Us Your Investment Thesis.
          </h2>
          <p className="text-xl font-medium tracking-[-0.02em] text-lime sm:text-2xl" data-id="element-80" data-mp="3755izxz4wnnz">
            We&apos;ll Show You What DiligenceGPT Sees.
          </p>
          <p className="max-w-2xl text-[15px] leading-relaxed text-text-secondary sm:text-base" data-id="element-81" data-mp="2se58zoiqolpq">
            See how DiligenceGPT can score your pipeline, structure diligence, surface risks, benchmark
            opportunities and discover companies aligned with your investment mandate.
          </p>

          <CtaButton href={DEMO_URL} event="final_book_demo_click" size="xl" className="mt-4 w-full px-10 py-5 text-base sm:w-auto" data-id="element-82" data-mp="3px6m5cixz037">
            Book Your Demo
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-83" data-mp="3ussm4gzwx6cf" />
          </CtaButton>

          <ul className="mt-6 grid w-full gap-3 sm:grid-cols-3" data-id="element-84" data-mp="3prv4q6mq8gbz">
            {REASSURANCE.map(item => <li key={item.text} className="flex items-start gap-2.5 rounded-xl border border-hairline-soft bg-panel/60 px-4 py-3 text-left text-xs text-text-secondary" data-id="element-85" data-mp="3lr1gtd9ab1j3">
                <item.icon className="mt-0.5 h-4 w-4 shrink-0 text-lime" aria-hidden="true" data-id="element-86" data-mp="3bzookkjkq9cj" />
                {item.text}
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col items-center gap-1" data-id="element-87" data-mp="324wqlfm2xkh8">
            <p className="text-2xl font-semibold tracking-[-0.03em] text-text-primary" data-id="element-88" data-mp="2y2i9p11z0usl">{BRAND.product}</p>
            <p className="text-sm text-text-secondary" data-id="element-89" data-mp="2t2dtzd8w043f">{BRAND.tagline}</p>
          </div>
        </Reveal>
      </div>
    </section>;
}